module.exports = __webpack_public_path__ + "static/img/063.4ad5d91.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/063.jpg
// module id = ks4Y
// module chunks = 0